import request from '@/router/axios';

// 新增公告
export const save = (row) => {
  return request({
    url: '/api/businessnotice/save',
    method: 'post',
    data: row
  })
}

// 列表
export const getList = (current, size, params,search) => {
  return request({
    url: '/api/businessnotice/list',
    method: 'post',
    data: {
      current,
      size,
      ...params,
      ...search
    },
  })
}

// 签发
export const sign = ({ids, signStatus}) => {
  return request({
    url: '/api/businessnotice/sign',
    method: 'post',
    params: {
      ids,
      signStatus
    }
  })
}

// 删除
export const remove = (ids) => {
  return request({
    url: `/api/businessnotice/remove`,
    method: 'delete',
    params: {
      ids,
    }
  })
}

// 修改
export const update = (row) => {
  return request({
    url: '/api/businessnotice/update',
    method: 'post',
    data: row
  })
}

// 修改
export const businessnoticeDetail = (id) => {
  return request({
    url: '/api/businessnotice/detail',
    method: 'get',
    params: {
      id
    }
  })
}

